import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import { useTheme } from '@mui/material';

export const Theatre = ({ size = 'large' }) => {
  const theme = useTheme();

  return (
    <TheaterComedyIcon
      fontSize={size}
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
